export interface HistoryKpiCardData {
  title: string;
  value: number;
  valueComparison: number | undefined;
  previousValue: number | undefined;

  data: Record<string, number>;
  chartLineColor: string;
  chartFillColor: string;
  listFilter: unknown | undefined;
  kpiSemanticDirection: Direction;
}

export enum Direction {
  INCREASE_IS_GOOD = 'increase_is_good',
  DECREASE_IS_GOOD = 'decrease_is_good',
}
